/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import { Checkbox, Grid, makeStyles, Typography } from '@material-ui/core';
import { useTableFilters } from 'hooks/useTableFilters';
import TableItems, { TableCell, TableRow } from 'components/TableItems';
import i18n from 'i18n';
import { getAllClientsRequest } from 'modules/clients/actions';
import {
  BulkClientsFields,
  ListBulkClientsProps,
} from 'modules/environments/interfaces';

import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import ApplicationState from 'store/interfaces';
import {
  editBulkClientsRequest,
  getBulkClientsRequest,
} from 'modules/environments/actions';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Formik, Form } from 'formik';
import ScreenStatesApplications from 'containers/Clients/ApplicationsClients/ScreenStatesApplications';
import AutoSwitch from 'components/AutoSwitch';
import Button from 'components/Button';
import { modalClose, modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import palette from 'theme/palette';

import TitleDivider from 'components/TitleDivider';
import DynamicTextField from 'components/DynamicTextField';
import { SearchBar } from 'components/SearchBar';
import VerificationCode from 'components/VerificationCode';
import styles, { overrideSwitch } from '../styles';
import screenFields from '../screenFields';
import schema from '../schema';
import { initialQuery } from '..';

interface Props {
  isLoadingBulkClients: boolean;
  bulkClients: ListBulkClientsProps;
  verificationCodeRef: React.MutableRefObject<string[]>;
  setVerificationCode: React.Dispatch<React.SetStateAction<string[]>>;
  editBulkClientsRequest: (props) => void;
  modalClose: () => void;
  modalOpen: (props: ModalFields) => void;
  getBulkClientsRequest: (props) => void;
}

const CopyAdminToggle = ({
  isLoadingBulkClients,
  bulkClients,
  verificationCodeRef,
  setVerificationCode,
  editBulkClientsRequest,
  modalClose,
  modalOpen,
  getBulkClientsRequest,
}: Props) => {
  interface ClientInfo {
    client_uuid: string;
    name: string;
  }
  const [selectedAll, setSelectedAll] = React.useState(false);
  const [checks, setChecks] = React.useState<ClientInfo[]>([]);
  const [state, setState] = React.useState<boolean>(true);
  const [activeAll, setActiveAll] = React.useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const classes = makeStyles(styles(state))();
  const {
    query,
    searchValue,
    itemOrder,
    handleOrder,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    setSearchValue,
  } = useTableFilters(initialQuery);

  const getBulkClients = () => {
    getBulkClientsRequest({
      id,
      query: { ...query, copy_admin: state ? 'False' : 'True' },
    });
  };

  React.useEffect(() => {
    getBulkClients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getBulkClientsRequest, query, state]);

  const headers = [
    {
      key: 'nome',
      i18n: 'CLIENT_NAME_KEY',
      order: true,
    },
    {
      key: 'cc_admin',
      i18n: 'BULK_CLIENTS.COPY_EMAIL_ADMIN_KEY',
      order: false,
      centerTitle: true,
    },
  ];

  const handleAllCheck = () => {
    if (!selectedAll) {
      const clientsInfo: ClientInfo[] = bulkClients?.results.map(item => ({
        client_uuid: item?.client_uuid || '',
        name: item?.name || '',
      }));
      setChecks(clientsInfo);
    } else {
      setChecks([]);
    }
    setSelectedAll(!selectedAll);
  };

  const handleCheck = (uuid: string, name: string) => {
    const findCheckId = checks.find(item => item?.client_uuid === uuid);
    if (!findCheckId) {
      setChecks([...checks, { client_uuid: uuid, name }]);
    } else {
      const filteredChecks = checks.filter(item => item?.client_uuid !== uuid);
      setChecks(filteredChecks);
    }
  };

  const clientUuids: string[] = checks.map(client => client?.client_uuid);
  const handleConfirm = (values: any) => {
    const verificationCodeToSend = verificationCodeRef.current;
    editBulkClientsRequest({
      id,
      dataValues: {
        operator_data: {
          action_reason: values?.action_reason,
          restricted_action_code: verificationCodeToSend.join(''),
        },
        clients_data: [
          {
            cli_uuids: clientUuids,
            copy_admin: !!state,
          },
        ],
      },
    });
    modalClose();
  };

  const handleSubmit = (values: any) => {
    setVerificationCode(Array(6).fill(''));
    editBulkClientsRequest({
      id,
      dataValues: {
        operator_data: {
          action_reason: values?.action_reason,
          password: values?.password,
        },
        clients_data: [
          {
            cli_uuids: clientUuids,
            copy_admin: !!state,
          },
        ],
      },
    });
    modalOpen({
      title: i18n.t('VERIFICATION_CODE_KEY'),
      content: (
        <VerificationCode
          length={6}
          setVerificationCode={setVerificationCode}
          onRetry={() => {
            editBulkClientsRequest({
              id,
              dataValues: {
                operator_data: {
                  action_reason: values?.action_reason,
                  password: values?.password,
                },
                clients_data: [
                  {
                    cli_uuids: clientUuids,
                    copy_admin: !!state,
                  },
                ],
              },
            });
          }}
          onConfirm={() => {
            handleConfirm(values);
          }}
        />
      ),
      fullWidth: true,
    });
  };

  return (
    <Grid container spacing={2} className={classes.container}>
      <Grid container justify="center">
        <AutoSwitch
          overrideClasses={overrideSwitch(state)}
          label={
            <Typography className={classes.switchText}>
              {state ? i18n.t('ACTIVATE_KEY') : i18n.t('INACTIVATE_KEY')}
            </Typography>
          }
          id="toggle-activate-inactivate"
          size="medium"
          onChange={() => setState(!state)}
          checked={state}
        />
      </Grid>
      <Grid container>
        <Grid
          container
          justify="flex-start"
          className={classes.checkboxActivateAll}
        >
          <Checkbox
            onChange={() => {
              setActiveAll(!activeAll);
              setChecks([]);
            }}
            checked={activeAll}
            id="change-all-clients"
          />
          <Typography className={classes.activeAllText}>
            {state
              ? i18n.t('BULK_CLIENTS.ACTIVATE_COPY_ADMIN_IN_ALL_CLIENTS_KEY')
              : i18n.t('BULK_CLIENTS.INACTIVATE_COPY_ADMIN_IN_ALL_CLIENTS_KEY')}
          </Typography>
        </Grid>
        {!activeAll && (
          <>
            <SearchBar
              id="search-client"
              isLoading={isLoadingBulkClients}
              searchValue={searchValue}
              handleSearch={handleSearch}
              setSearchValue={setSearchValue}
            />
            <TableItems
              header={
                <>
                  <TableCell className={classes.checkboxCell}>
                    <Checkbox
                      onChange={handleAllCheck}
                      id="select-all-clients-environment"
                    />
                  </TableCell>
                  {headers.map(item => (
                    <TableCell
                      key={item?.key}
                      centerTitle={item?.centerTitle}
                      markOderItem={itemOrder === item?.key}
                      order={item?.order}
                      handleOrder={() =>
                        item?.order ? handleOrder(item?.key) : null
                      }
                    >
                      {i18n.t(item?.i18n)}
                    </TableCell>
                  ))}
                </>
              }
              renderItems={(item: BulkClientsFields, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.checkboxCell}>
                    <Checkbox
                      onChange={() =>
                        handleCheck(item?.client_uuid || '', item?.name || '')
                      }
                      checked={
                        !!checks.find(
                          check => check?.client_uuid === item?.client_uuid
                        )
                      }
                    />
                  </TableCell>
                  <TableCell>{item?.name}</TableCell>
                  <TableCell textAlignCenter centerTitle>
                    <ScreenStatesApplications
                      type={item?.copy_admin ? 'active' : 'inactive'}
                    />
                  </TableCell>
                </TableRow>
              )}
              isLoading={isLoadingBulkClients}
              data={bulkClients}
              overrideRowsCount={10}
              onChangeLimit={handleLimitChange}
              onChangePage={handlePageChange}
              notFoundText={i18n.t('NO_CLIENT_KEY')}
              smallLoading={true}
            />
          </>
        )}
      </Grid>
      <Grid container justify="flex-end" className={classes.buttons}>
        {state ? (
          <Button
            id="activate-button"
            submitButton
            disabled={checks.length === 0 && !activeAll}
            onClick={() => {
              modalOpen({
                title: i18n.t('BULK_CLIENTS.CONFIRM_ACTIVATE_COPY_ADMIN_KEY'),
                content: (
                  <>
                    <Grid container justify="center">
                      <ErrorOutlineIcon
                        style={{
                          color: palette.deepBlue,
                          width: 30,
                          height: 30,
                        }}
                      />
                    </Grid>
                    {!activeAll ? (
                      <>
                        <Grid container justify="center">
                          <Typography
                            style={{ fontSize: 12, marginBottom: 12 }}
                          >
                            {i18n.t(
                              'BULK_CLIENTS.CONFIRM_ACTIVATE_COPY_ADMIN_IN_CLIENTS_KEY'
                            )}
                          </Typography>
                        </Grid>
                        <TableItems
                          header={
                            <>
                              <TableCell className={classes.tableRow}>
                                {i18n.t('CLIENT_NAME_KEY')}
                              </TableCell>
                            </>
                          }
                          renderItems={(item: BulkClientsFields, index) => (
                            <TableRow key={index}>
                              <TableCell>{item?.name}</TableCell>
                            </TableRow>
                          )}
                          isLoading={isLoadingBulkClients}
                          data={{
                            count: 0,
                            next: '',
                            previous: '',
                            results: checks,
                          }}
                          onChangeLimit={handleLimitChange}
                          onChangePage={handlePageChange}
                          notFoundText={i18n.t('NO_CLIENT_KEY')}
                          notFooter
                          smallLoading={true}
                        />
                      </>
                    ) : (
                      <Typography style={{ fontSize: 12 }}>
                        {i18n.t(
                          'BULK_CLIENTS.CONFIRM_ACTIVATE_COPY_ADMIN_IN_ALL_CLIENTS_CLIENTS_KEY'
                        )}
                      </Typography>
                    )}
                    <TitleDivider
                      overrideClasses={{
                        title: { margin: '12px 4px 8px 4px', fontSize: 12 },
                      }}
                    >
                      {i18n.t('BULK_CLIENTS.ACTIVATE_LIMIT_TO_CONFIRM_KEY')}
                    </TitleDivider>
                    <Formik
                      initialValues={{ action_reason: '' }}
                      enableReinitialize
                      validationSchema={schema}
                      validateOnChange
                      validateOnBlur
                      onSubmit={handleSubmit}
                    >
                      {({ setFieldValue, errors, values, submitForm }) => {
                        return (
                          <React.Fragment>
                            <Form>
                              <Grid container>
                                <Grid
                                  container
                                  spacing={2}
                                  className={classes.fields}
                                >
                                  <DynamicTextField
                                    {...screenFields[0]}
                                    setFieldValue={setFieldValue}
                                    value={values?.action_reason}
                                    errors={errors}
                                  />
                                </Grid>
                              </Grid>
                              <Grid
                                container
                                justify="flex-end"
                                style={{ marginTop: 12 }}
                              >
                                <Button
                                  submitButton
                                  id="confirm-button"
                                  onClick={submitForm}
                                  isLoading={isLoadingBulkClients}
                                >
                                  {i18n.t('CONTINUE_KEY')}
                                </Button>
                                <Button
                                  id="cancel-button"
                                  variant="outlined"
                                  onClick={modalClose}
                                >
                                  {i18n.t('CANCEL_KEY')}
                                </Button>
                              </Grid>
                            </Form>
                          </React.Fragment>
                        );
                      }}
                    </Formik>
                  </>
                ),
              });
            }}
          >
            {i18n.t('NEXT_KEY')}
          </Button>
        ) : (
          <Button
            id="inactivate-button"
            submitButton
            disabled={checks.length === 0 && !activeAll}
            onClick={() => {
              modalOpen({
                title: i18n.t('BULK_CLIENTS.CONFIRM_INACTIVATE_COPY_ADMIN_KEY'),
                content: (
                  <>
                    <Grid container justify="center">
                      <ErrorOutlineIcon
                        style={{
                          color: palette.deepBlue,
                          width: 30,
                          height: 30,
                        }}
                      />
                    </Grid>
                    {!activeAll ? (
                      <>
                        <Grid container justify="center">
                          <Typography
                            style={{ fontSize: 12, marginBottom: 12 }}
                          >
                            {i18n.t(
                              'BULK_CLIENTS.CONFIRM_INACTIVATE_COPY_ADMIN_IN_CLIENTS_KEY'
                            )}
                          </Typography>
                        </Grid>
                        <TableItems
                          header={
                            <>
                              <TableCell className={classes.tableRow}>
                                {i18n.t('CLIENT_NAME_KEY')}
                              </TableCell>
                            </>
                          }
                          renderItems={(item: BulkClientsFields, index) => (
                            <TableRow key={index}>
                              <TableCell>{item?.name}</TableCell>
                            </TableRow>
                          )}
                          isLoading={isLoadingBulkClients}
                          data={{
                            count: 0,
                            next: '',
                            previous: '',
                            results: checks,
                          }}
                          onChangeLimit={handleLimitChange}
                          onChangePage={handlePageChange}
                          notFoundText={i18n.t('NO_CLIENT_KEY')}
                          notFooter
                          smallLoading={true}
                        />
                      </>
                    ) : (
                      <Typography style={{ fontSize: 12 }}>
                        {i18n.t(
                          'BULK_CLIENTS.CONFIRM_INACTIVATE_COPY_ADMIN_IN_ALL_CLIENTS_CLIENTS_KEY'
                        )}
                      </Typography>
                    )}
                    <TitleDivider
                      overrideClasses={{
                        title: { margin: '12px 4px 8px 4px', fontSize: 12 },
                      }}
                    >
                      {i18n.t('BULK_CLIENTS.INACTIVATE_LIMIT_TO_CONFIRM_KEY')}
                    </TitleDivider>
                    <Formik
                      initialValues={{ action_reason: '' }}
                      enableReinitialize
                      validationSchema={schema}
                      validateOnChange
                      validateOnBlur
                      onSubmit={handleSubmit}
                    >
                      {({ setFieldValue, errors, values, submitForm }) => {
                        return (
                          <React.Fragment>
                            <Form>
                              <Grid container>
                                <Grid
                                  container
                                  spacing={2}
                                  className={classes.fields}
                                >
                                  <DynamicTextField
                                    {...screenFields[0]}
                                    setFieldValue={setFieldValue}
                                    value={values?.action_reason}
                                    errors={errors}
                                  />
                                </Grid>
                              </Grid>
                              <Grid
                                container
                                justify="flex-end"
                                style={{ marginTop: 12 }}
                              >
                                <Button
                                  submitButton
                                  id="confirm-button"
                                  onClick={submitForm}
                                  isLoading={isLoadingBulkClients}
                                >
                                  {i18n.t('CONTINUE_KEY')}
                                </Button>
                                <Button
                                  id="cancel-button"
                                  variant="outlined"
                                  onClick={modalClose}
                                >
                                  {i18n.t('CANCEL_KEY')}
                                </Button>
                              </Grid>
                            </Form>
                          </React.Fragment>
                        );
                      }}
                    </Formik>
                  </>
                ),
              });
            }}
          >
            {i18n.t('NEXT_KEY')}
          </Button>
        )}

        <Button id="cancel-button" variant="outlined" onClick={modalClose}>
          {i18n.t('CLOSE_KEY')}
        </Button>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { environmentSelected, bulkClients, isLoadingBulkClients },
}: ApplicationState) => ({
  environmentSelected,
  bulkClients,
  isLoadingBulkClients,
});

export default connect(mapStateToProps, {
  getAllClientsRequest,
  modalClose,
  editBulkClientsRequest,
  modalOpen,
  getBulkClientsRequest,
})(CopyAdminToggle);
